import { useQuery } from '@tanstack/react-query';
import { newsEntriesGet2 } from '~/generated';
import { extractData } from '~/utils/query-utils';

type Attachment = {
  id: number;
  blobId: string;
  fileName: string;
  contentType: string;
};

type NewsEntry = {
  id: number;
  title: string;
  date: string;
  content: string;
  revision: number;
  isRead: 'Unread' | 'ReadButChanged' | 'Read';
  attachments: Attachment[];
  visibility: string[];
  validFrom: string;
  validUntil: string | null;
};

export const useNewsEntry = (id: number) =>
  useQuery({
    queryFn: async () => {
      const result = await extractData(
        newsEntriesGet2({ path: { id }, responseType: 'json' })
      );
      return result as unknown as NewsEntry;
    },
    queryKey: ['NewsEntries', id],
  });
